<script>
    import PageFooter from "./PageFooter.svelte";
    import PageHeader from "./PageHeader.svelte";

    export let main_class = '';
    export let hide_header = false;
    export let hide_footer = false;

</script>

<section class="flex flex-col justify-between items-center min-h-[100dvh]">
    {#if !hide_header}
        <PageHeader />
    {/if}
    <main class="flex-1 w-full {main_class}"><slot /></main>
    {#if !hide_footer}
        <PageFooter />
    {/if}
</section>

<style>
    section {
        background: var(--page-background);
        color: var(--symbols-default);
    }
</style>
